import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ObjectToQueryParam } from "../utils";

export const fetchAuditLogByAttachmentId = createAsyncThunk("auditLog/fetchByAttachmentId", async ({ id, filter }: { id: string, filter?: { page: number, count: number } }, { getState }) => {
  let queryParams = '';
  if (filter) {
    queryParams = ObjectToQueryParam(filter);
  }
  
  return axios.get(`/audit-log/${id}?${queryParams}`).then((res) => ({ response: res.data, queryParams }));
});

// Then, handle actions in your reducers:
const auditLogSlice = createSlice({
  name: "auditLog",
  initialState: {
    loading: false,
    totalCount: 0,
    queryParams: "",
    data: [] as AuditLogRecord[],
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchAuditLogByAttachmentId.fulfilled.type]: (state, action) => {
      const data = action.payload.response.data;
      state.data = data;
      state.totalCount = action.payload.response.totalCount;
      state.queryParams = action.payload.queryParams;
      state.loading = false;
    },
    [fetchAuditLogByAttachmentId.pending.type]: (state, action) => {
      state.loading = true;
    },
    [fetchAuditLogByAttachmentId.rejected.type]: (state, action) => {
      state.loading = false;
    },
  },
});

export default auditLogSlice.reducer;

export interface AuditLogRecord {
  id: string;
  attachmentId: string;
  auditDate: string;
  user: string;
  changes: AuditLogChange[];
}

export interface AuditLogChange {
  property: string;
  oldValue: string;
  newValue: string;
}
